/**
 * Panel configuration for Division 26 reusable components.
 * Defines columns for the list page and fields for the create/edit modal.
 */

import React from 'react';
import { formatDateUS } from './maintenanceConfig';

const MaintenanceBadge = ({ date }) => {
  if (!date) {
    return <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-100 text-slate-400">No Maintenance Recorded</span>;
  }
  const now = new Date();
  const mDate = new Date(date + 'T00:00:00');
  const diffDays = Math.floor((now - mDate) / (1000 * 60 * 60 * 24));
  const color = diffDays <= 30
    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
    : 'bg-amber-50 text-amber-700 border-amber-200';
  return <span className={`text-[10px] px-1.5 py-0.5 rounded border ${color}`}>Last Maintenance: {formatDateUS(date)}</span>;
};

export const panelListConfig = {
  moduleName: 'Panel',
  testIdPrefix: 'elec-panel',
  apiBase: '/electrical-panels',
  manufacturerApi: '/electrical-panel-manufacturers',
  columns: [
    {
      key: 'name',
      label: 'Panel Name',
      cellClass: 'font-medium text-slate-900',
      render: (item) => (
        <div>
          <div className="font-medium text-slate-900">{item.name}</div>
          <div className="mt-0.5"><MaintenanceBadge date={item.lastMaintenanceDate} /></div>
        </div>
      ),
    },
    { key: 'voltage', label: 'Voltage', cellClass: 'text-slate-700' },
    { key: 'phase', label: 'Phase', render: (item) => `Phase ${item.phase}` },
    { key: 'location', label: 'Location', cellClass: 'text-slate-700' },
    { key: 'circuits', label: 'Circuits', cellClass: 'text-slate-700', render: (item) => item.circuits ?? '-' },
  ],
};

export const panelFormConfig = {
  moduleName: 'Panel',
  testIdPrefix: 'elec-panel',
  fields: [
    { key: 'name', label: 'Name', type: 'text', required: true, placeholder: 'Enter panel name' },
    { key: 'panelType', label: 'Type', type: 'select', required: true, options: ['Lighting', 'Distribution', 'Emergency'] },
    { key: 'location', label: 'Location', type: 'location', required: true, placeholder: 'Select location' },
    { key: 'manufacturerId', label: 'Manufacturer', type: 'manufacturer', required: true },
    { key: 'model', label: 'Model', type: 'text', required: true, placeholder: 'Enter model number' },
    { key: 'phase', label: 'Phase', type: 'select', required: true, options: ['1', '3'] },
    { key: 'busRating', label: 'Bus Rating', type: 'text', required: true, numeric: true, placeholder: 'Enter bus rating' },
    { key: 'voltage', label: 'Voltage', type: 'select', required: true, options: ['208/120', '480/277'] },
    { key: 'mainBreaker', label: 'Main Breaker', type: 'text', required: true, numeric: true, placeholder: 'Enter main breaker value' },
    { key: 'installDate', label: 'Install Date', type: 'date', required: true },
    { key: 'circuits', label: 'Circuits', type: 'text', required: true, numeric: true, placeholder: 'Enter number of circuits' },
    { key: 'notes', label: 'Notes', type: 'textarea', required: false, fullWidth: true, placeholder: 'Additional notes...' },
  ],
};
